import React, { useEffect, useState, useReducer, useCallback } from "react";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// import Footer from "../../../components/footer/Footer";
import MainFooter from "../../../components/mainfooter/MainFooter";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartSingleProduct,
  getCartCustomizeProduct,
} from "../../../redux/slices/newCartSlice";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import ProductCard from "../../../components/productcard/ProductCard";
import CustomizeProductCard from "../../../components/productcard/CustomizeProductCard";
import "./collection.css";
import { axiosInstance } from "../../../config";
import { toastError } from "../../../utils/reactToastify";
import Preloader from "../../../components/preloader/Preloader";
import { getPriceForCollectionClient } from "../../../utils/varientimge/getPrice";
import { REACT_APP_URL } from "../../../config";
import { fetchWishlistForProductList } from "../../../redux/slices/newWishlistSlice";
import { isSingleProductInWishlist } from "../../../utils/isInWishlist/isSingleProduct";
import { isCustomizedProductInWishlist } from "../../../utils/isInWishlist/isCustomizedProduct";
// import ProductFilter from "../../../components/SideFilter/ProductFilter";
import ClientCollectionCard from "./ClientCollectionCard";
import "./ClientCollectionCard.css";
import { reducer, initialState, ActionTypes } from "./collectionReducer";
import ProductSlide from "../../../components/productMagnification/ProductSlide";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "97%",
  height: "95%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const calculateCustomizedPrice = (productDetails, combinations, priceFor) => {
  if (productDetails && combinations?.length > 0) {
    const { DefaultWidth, DefaultHeight } = productDetails || {};

    const totalCustomizedPrice =
      productDetails[priceFor] +
      getPriceForCollectionClient(productDetails, combinations, {
        DefaultWidth: DefaultWidth ? DefaultWidth : 0,
        DefaultHeight: DefaultHeight ? DefaultHeight : 0,
      });

    return totalCustomizedPrice;
  }
  return 0;
};

const ClientCollection = () => {
  const { wishlistProducts } = useSelector((state) => state.wishlist);
  const { whishlistdata } = useSelector((state) => state.whishlist);
  const { cartdata } = useSelector((state) => state.cart);

  const {
    cartSingleProduct,
    cartSingleLoading,
    cartCustomizeProduct,
    cartCustomizeProductLoading,
  } = useSelector((state) => state.newCartSlice);

  const { collectionname } = useParams();

  const [state, dispatchState] = useReducer(reducer, initialState);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    cartSingleProducts,
    cartCustomizeProducts,
    allChildCollections,
    collectiondetails,
    productCombinations,
    customizeProductCombinations,
  } = state;

  const [wishlistData, setWishlistData] = useState({
    singleProducts: [],
    customizedProducts: [],
  });

  const [loading, setLoading] = useState(false);
  const { userdetails } = useSelector((state) => state.auth);
  //Minnmium and maximum price
  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [suggestionData, setSuggestionData] = useState({
    collection: {},
    productCombination: [],
  });
  const [suggestionCustomizedData, setSuggestionCustomizedData] = useState({
    collection: {},
    customizedProductCombination: [],
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const middleUrls = (collectiondetails?.rootPath || []).slice(1);

      const queryString = middleUrls
        .map((url) => `url=${encodeURIComponent(url?.url)}`)
        .join("&");
      // console.log(queryString)

      const [suggestionResponse, suggestionCustomizedResponse] =
        await Promise.all([
          axiosInstance.get(
            `/api/collection/collectiondetails/suggestion/getSuggestionProduct?${queryString}`
          ),
          axiosInstance.get(
            `/api/collection/collectiondetails/suggestion/getSuggestionCustomizedproduct?${queryString}`
          ),
        ]);

      const { data, productsCombinations } = suggestionResponse.data;

      if (suggestionResponse?.data?.success) {
        const mapData = data.reduce((acc, item) => {
          acc[item._id] = item;
          return acc;
        }, {});

        setSuggestionData({
          collection: mapData,
          productCombination: productsCombinations,
        });
      }

      if (suggestionCustomizedResponse?.data?.success) {
        const { data, customizeProductsCombinations } =
          suggestionCustomizedResponse.data;

        const mapData = data.reduce((acc, item) => {
          acc[item._id] = item;
          return acc;
        }, {});

        setSuggestionCustomizedData({
          collection: mapData,
          customizedProductCombination: customizeProductsCombinations,
        });
      }
    };

    if (
      collectiondetails &&
      collectiondetails?.rootPath &&
      collectiondetails?.rootPath.length > 0
    ) {
      fetchData();
    }
  }, [collectiondetails]);

  useEffect(() => {
    if (userdetails && Object.keys(userdetails).length > 0) {
      Promise.all([
        dispatch(fetchWishlistForProductList()),
        dispatch(getCartSingleProduct({ id: userdetails?._id })),
        dispatch(getCartCustomizeProduct({ id: userdetails?._id })),
      ]);
    }
  }, [dispatch, userdetails]);

  useEffect(() => {
    if (
      wishlistProducts &&
      userdetails &&
      Object.keys(userdetails).length > 0
    ) {
      const singleProducts = [];
      const customizedProducts = [];

      for (let product of wishlistProducts) {
        if (product?.singleProductId) {
          singleProducts.push(product);
        } else if (product?.customizedProductId) {
          customizedProducts.push(product);
        }
      }

      setWishlistData({ singleProducts, customizedProducts });
    } else if (
      whishlistdata?.length > 0 &&
      userdetails &&
      Object.keys(userdetails).length === 0
    ) {
      const singleProducts = [];
      const customizedProducts = [];

      for (let product of whishlistdata) {
        if (product?.singleProductId) {
          singleProducts.push(product);
        } else if (product?.customizedProductId) {
          customizedProducts.push(product);
        }
      }
      setWishlistData({ singleProducts, customizedProducts });
    }
  }, [wishlistProducts, userdetails, whishlistdata]);

  const fetchData = useCallback(async (url) => {
    try {
      setLoading(true);
      const [collectionDetailsResponse, customizeProductCombinationsresponse] =
        await Promise.all([
          axiosInstance.get(`/api/collection/collectiondetails/${url}`),
          axiosInstance.get(
            `/api/collection/collectiondetails/customize/${url}`
          ),
        ]);
      if (collectionDetailsResponse?.data.success) {
        dispatchState({
          type: ActionTypes.SET_COLLECTION_DETAILS,
          payload: collectionDetailsResponse?.data?.data,
        });

        dispatchState({
          type: ActionTypes.SET_PRODUCT_COMBINATIONS,
          payload: collectionDetailsResponse?.data?.productsCombinations,
        });
      }

      if (customizeProductCombinationsresponse?.data?.success) {
        dispatchState({
          type: ActionTypes.SET_CUSTOMIZE_PRODUCT_COMBINATION,
          payload:
            customizeProductCombinationsresponse?.data
              ?.customizeProductsCombinations,
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toastError(error?.response?.data?.message);
    }
  }, []);

  // fetching single product by url
  useEffect(() => {
    if (collectionname) {
      Promise.all([fetchData(collectionname)]);
    }
  }, [fetchData, collectionname]);

  useEffect(() => {
    if (
      cartSingleLoading === "fulfilled" &&
      cartSingleProduct &&
      userdetails &&
      Object.keys(userdetails).length > 0
    ) {
      dispatchState({
        type: ActionTypes.SET_CART_SINGLE_PRODUCT,
        payload: cartSingleProduct,
      });
    } else if (cartdata?.length > 0) {
      const singleProducts = [];
      const customizedProducts = [];

      for (let product of cartdata) {
        if (product?.singleProductId) {
          singleProducts.push(product);
        } else if (product?.customizedProductId) {
          customizedProducts.push(product);
        }
      }

      dispatchState({
        type: ActionTypes.SET_CART_SINGLE_PRODUCT,
        payload: singleProducts,
      });

      dispatchState({
        type: ActionTypes.SET_CART_CUSTOMIZE_PRODUCT,
        payload: customizedProducts,
      });
    }
  }, [cartSingleLoading, cartSingleProduct, userdetails, cartdata]);

  useEffect(() => {
    if (cartCustomizeProductLoading === "fulfilled" && cartCustomizeProduct) {
      dispatchState({
        type: ActionTypes.SET_CART_CUSTOMIZE_PRODUCT,
        payload: cartCustomizeProduct,
      });
    }
  }, [cartCustomizeProductLoading, cartCustomizeProduct]);

  const fetchAllChildCollection = async (id) => {
    const { data } = await axiosInstance.get(
      `/api/collection/get-all-child-collection/${id}`
    );

    if (data.success) {
      dispatchState({
        type: ActionTypes.SET_ALL_CHILD_COLLECTIONS,
        payload: data?.data,
      });
    }
  };

  useEffect(() => {
    if (collectiondetails?._id) {
      fetchAllChildCollection(collectiondetails?._id);
    }
  }, [collectiondetails]);

  // useEffect(() => {
  //   if (minprice && maxprice) {
  //     setfilteredProduct(
  //       product
  //         .filter((p) => p.CustomizedProduct === false)
  //         .filter(
  //           (p) => p.OriginalPrice >= minprice && p.OriginalPrice <= maxprice
  //         )
  //     );
  //   }
  // }, [minprice, maxprice]);

  let isArchitect = "";

  if (
    userdetails &&
    Object.keys.length > 0 &&
    userdetails.userRole?.find((role) => role?.name === "Architect")
  ) {
    isArchitect = userdetails?._id;
  }

  const handleFilterSubmit = (e) => {
    e.preventDefault();
  };

  if (loading) {
    return <Preloader />;
  }

  // console.log("collectiondetails?.rootPath", collectiondetails?.rootPath);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="fingerprint"
              color="success"
              sx={{ float: "right", top: 0, right: 0, position: "absolute" }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            <ProductSlide
              product={
                productCombinations?.length > 0
                  ? productCombinations
                  : customizeProductCombinations?.length > 0
                  ? customizeProductCombinations
                  : []
              }
              productAccess={
                productCombinations?.length > 0
                  ? "singleProductId"
                  : customizeProductCombinations?.length > 0
                  ? "productId"
                  : ""
              }
              collectiondetails={collectiondetails}
              activeIndex={0}
              path="product"
            />
          </Box>
        </Fade>
      </Modal>

      <StickySidebar />
      {/* <MainHeader
        isImageAvailable={
          collectiondetails?.collectionHeaderImage?.pngImage ? true : false
        }
      /> */}
      <MainHeader
        isImageAvailable={
          collectiondetails?.collectionHeaderImage?.pngImage ? true : false
        }
      />
      <div
        className="header-container"
        style={{
          height: collectiondetails?.collectionHeaderImage?.pngImage
            ? "60vh"
            : "11vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {collectiondetails?.collectionHeaderImage?.pngImage?.endsWith(
          ".mp4"
        ) ? (
          <video
            autoPlay
            muted
            loop
            playsInline
            className="header-video"
            width="100%"
          >
            <source
              src={`${REACT_APP_URL}/images/header/${collectiondetails.collectionHeaderImage.pngImage}`}
              type="video/mp4"
            />
          </video>
        ) : (
          <div
            className="header-image"
            style={{
              width: "100%",
              height: "100%",
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${collectiondetails?.collectionHeaderImage?.pngImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        )}
      </div>

      <div style={{ padding: "10px 10px 0px 10px" }}>
        <>
          <p
            className="mb-1"
            style={{ color: "#222", display: "flex", alignItems: "center" }}
          >
            <Link to={`/`}>
              <HomeIcon style={{ fontSize: 16, color: "#222" }} />
            </Link>{" "}
            {collectiondetails &&
              collectiondetails?.rootPath?.length > 0 &&
              collectiondetails?.rootPath?.map((collections, index) => (
                <React.Fragment key={index}>
                  <KeyboardArrowRightIcon style={{ fontSize: 16 }} />
                  <Link
                    to={`/collection/${collections.url}`}
                    style={{
                      fontWeight: "700",
                      // letterSpacing: "1px",
                      textTransform: "uppercase",
                      color: "#222",
                    }}
                  >
                    {collections?.title}
                  </Link>{" "}
                </React.Fragment>
              ))}
            <KeyboardArrowRightIcon style={{ fontSize: 16 }} />
            <Link
              style={{
                fontWeight: "700",
                // letterSpacing: "1px",
                textTransform: "uppercase",
                color: "#222",
              }}
            >
              {collectiondetails?.url ? collectiondetails?.url : collectionname}
            </Link>{" "}
          </p>
        </>
      </div>
      {/* {console.log("allChildCollections", allChildCollections)} */}
      <div className="row" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
        {allChildCollections && allChildCollections.length > 0 && (
          <>
            <div
            // style={{
            //   background: "linear-gradient(to top, #F7F8FC, #ffffff)",
            // }}
            >
              <h3
                style={{
                  textTransform: "uppercase",
                  padding: "20px 0px 0px 20px",
                  fontWeight: "600",
                }}
              >
                Featured Categories
              </h3>
              <div
                className="row"
                style={{ paddingRight: "0px", paddingLeft: "0px" }}
              >
                {allChildCollections.map((collection) => (
                  <ClientCollectionCard p={collection} key={collection?._id} />
                ))}
              </div>
            </div>
            {/* <center><hr style={{width:"40%"}}></hr></center> */}
          </>
        )}
        <>
          <div
            className="row"
            style={{
              marginTop: "20px",
              paddingRight: "0px",
              paddingLeft: "0px",
            }}
          >
            <p
              style={{
                textAlign: "center",
                letterSpacing: "2px",
              }}
            >
              OUR COLLECTION
            </p>
            <h1 style={{ textAlign: "center", textTransform: "uppercase" }}>
              EXCLUSIVE DESIGN COLLECTIONS
            </h1>

            <div className="row pricesectionstyle">
              <form onSubmit={handleFilterSubmit}>
                <div
                  className="col-lg-4 col-12 pricesectionstyle"
                  style={{ float: "left" }}
                >
                  <div style={{ paddingLeft: "20px" }}>
                    <h6 className="labelcolor">Price Range</h6>
                    <div className="d-flex w-100">
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        onChange={(e) => setMinPrice(e.target.value)}
                      />{" "}
                      <span
                        className="labelcolor"
                        style={{ margin: "0px 20px 0px 20px" }}
                      >
                        to
                      </span>{" "}
                      <input
                        className="form-control"
                        type="number"
                        min={0}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-3 col-12 pricesectionstyle"
                  style={{ float: "left" }}
                >
                  <div className="pricesectionstyle1">
                    <h6 className="labelcolor">Sort By</h6>
                    <div className="d-flex w-100">
                      <select
                        id="inputState"
                        className="form-control"
                        // onChange={(e) => setsort(e.target.value)}
                      >
                        <option>Sort Products</option>
                        <option value="newest">Newest</option>
                        <option value="asc">Price (ASC)</option>
                        <option value="desc">Price (DESC)</option>
                      </select>
                    </div>
                  </div>
                </div>

                <span className="col-lg-4 col-12 px-4">
                  <button
                    type="submit"
                    className="mt-4 btn"
                    style={{ backgroundColor: "#324A42", color: "#fff" }}
                  >
                    Apply
                  </button>
                </span>
                <span className="col-lg-4">
                  <button
                    type="submit"
                    className="mt-4 btn"
                    onClick={handleOpen}
                    style={{ backgroundColor: "#324A42", color: "#fff" }}
                  >
                    Slide Show
                  </button>
                </span>
              </form>
            </div>

            <div
              className="row"
              style={{
                paddingLeft: "0px",
                paddingRight: "0px",
                marginTop: "10px",
                marginLeft: "12px",
              }}
            >
              {/* {console.log("productCombinations", productCombinations)}
              {console.log("collectiondetails", collectiondetails)}
              {console.log("collectionname", collectionname)}
              {console.log("wishlistData", wishlistData)}
              {console.log("cartSingleProducts", cartSingleProducts)} */}

              {/* single Product Card */}
              {productCombinations &&
                productCombinations.length > 0 &&
                // <div className="row p-3">
                productCombinations.map((combination) => (
                  <ProductCard
                    key={combination._id}
                    product={combination?.singleProductId}
                    colnumber={3}
                    customizedproductcardheight={"38vh"}
                    collectionUrl={collectiondetails?.url}
                    combinationImage={combination?.image}
                    productCombination={combination}
                    collectionname={collectionname}
                    wishlistData={wishlistData?.singleProducts || []}
                    isProductInWishlist={isSingleProductInWishlist}
                    isWishlist={false}
                    architectId={isArchitect}
                    cartData={cartSingleProducts || []}
                  />
                ))}

              {/* customized  Product Card */}
              {customizeProductCombinations &&
                customizeProductCombinations.length > 0 && (
                  // <div className="row p-3">
                  <>
                    {customizeProductCombinations.map((combination) => (
                      <CustomizeProductCard
                        key={combination?._id}
                        calculateCustomizedPrice={calculateCustomizedPrice}
                        product={combination?.productId}
                        colnumber={3}
                        collectionUrl={collectiondetails?.url}
                        customizedproductcardheight={"38vh"}
                        productCombination={combination?.productId}
                        combination={combination}
                        collectionname={collectionname}
                        wishlistData={wishlistData?.customizedProducts || []}
                        isProductInWishlist={isCustomizedProductInWishlist}
                        isWishlist={false}
                        cartData={cartCustomizeProducts || []}
                      />
                    ))}
                    {/* </div> */}
                  </>
                )}

              {(suggestionData.productCombination.length > 0 ||
                suggestionCustomizedData.customizedProductCombination.length >
                  0) && (
                <h1
                  style={{
                    margin: "20px 0",
                    textAlign: "center",
                    fontSize: "30px",
                    fontWeight: "700",
                  }}
                >
                  Similar Products
                </h1>
              )}

              {suggestionData.productCombination &&
                suggestionData.productCombination.length > 0 &&
                suggestionData.productCombination.map((combination) => {
                  const matchedCollections =
                    combination?.singleProductId?.Collection.map(
                      (collId) => suggestionCustomizedData.collection[collId]
                    ).filter(Boolean);
                  return (
                    <ProductCard
                      key={combination._id}
                      product={combination?.singleProductId}
                      colnumber={3}
                      customizedproductcardheight={"38vh"}
                      collectionUrl={matchedCollections?.[0]?.url}
                      combinationImage={combination?.image}
                      productCombination={combination}
                      collectionname={matchedCollections?.[0]?.url}
                      wishlistData={wishlistData?.singleProducts || []}
                      isProductInWishlist={isSingleProductInWishlist}
                      isWishlist={false}
                      architectId={isArchitect}
                      cartData={cartSingleProducts || []}
                    />
                  );
                })}

              {suggestionCustomizedData.customizedProductCombination &&
                suggestionCustomizedData.customizedProductCombination.length >
                  0 && (
                  // <div className="row p-3">
                  <>
                    {suggestionCustomizedData.customizedProductCombination.map(
                      (combination) => {
                        const matchedCollections =
                          combination?.productId?.Collection.map(
                            (coll) =>
                              suggestionCustomizedData.collection[coll?._id]
                          ).filter(Boolean);

                        return (
                          <CustomizeProductCard
                            key={combination?._id}
                            calculateCustomizedPrice={calculateCustomizedPrice}
                            product={combination?.productId}
                            colnumber={3}
                            collectionUrl={matchedCollections?.[0]?.url}
                            customizedproductcardheight={"38vh"}
                            productCombination={combination?.productId}
                            combination={combination}
                            collectionname={matchedCollections?.[0]?.url}
                            wishlistData={
                              wishlistData?.customizedProducts || []
                            }
                            isProductInWishlist={isCustomizedProductInWishlist}
                            isWishlist={false}
                            cartData={cartCustomizeProducts || []}
                          />
                        );
                      }
                    )}
                    {/* </div> */}
                  </>
                )}
            </div>
          </div>
        </>
        {/* ) : (
          <>
          <h4 className="text-center my-5"> No any Product found ! 😞</h4>
          </>
        )} */}
      </div>
      <br></br>
      <MainFooter />
    </>
  );
};

export default ClientCollection;
